import { baseAPI } from "../baseApi";

export const cardsApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение структуры информации для типов объектов
        getCardsStructure: builder.query<any, any>({
            query: ({ structureSuffix = "" }) => ({
                url: `structure?AuthToken=X&type=cards${structureSuffix}`
            })
        }),
        // запрос на получении информации об объекте
        getTableObjectInfo: builder.query<any, any>({
            query: ({ queryType, objectType, objectId }) => ({
                url: `${queryType}/${objectType}(${objectId})`
            })
        })
    })
})

export const {
    useGetTableObjectInfoQuery,
    useGetCardsStructureQuery
} = cardsApiSlice


